import React from "react";
import { Field, Form } from "react-final-form";
import { submit, validate } from "./EditServiceValuationPartFormSubmit";
import BMXTextField from "../../../../../../Components/Inputs/BMXTextField/BMXTextField";
import { Col, Row } from "react-bootstrap";
import { t } from "i18next";
import BMXButton from "../../../../../../Components/Buttons/BMXButton/BMXButton";

const EditServiceValuationPartForm = (props) => {
  const { initialValues, handleHide } = props;

  return (
    <Form
      initialValues={{
        ...initialValues,
      }}
      onSubmit={(val) => submit(val, props)}
      validate={validate}
    >
      {({ handleSubmit }) => (
        <form onSubmit={handleSubmit} className="EditServiceValuationPartForm">
          <Row>
            <Col xs={6}>
              <Field
                type="money"
                name="price"
                component={BMXTextField}
                label={t("global:editservicevaluationpartform.price")}
              />
            </Col>
            <Col xs={6}>
              <Field
                type="number"
                name="quantity"
                component={BMXTextField}
                label={t("global:editservicevaluationpartform.quantity")}
              />
            </Col>          
          </Row>
          <Row className=" d-flex justify-content-end">
            <Col className="mt-3 d-flex gap-3 justify-content-end">
              <BMXButton
                data-cy="submit"
                type="button"
                onClick={handleHide}
              >
                {t("global:close")}
              </BMXButton>
              <BMXButton
                data-cy="submit"
                bmxclass="Success"
                type="Submit"
                onClick={handleSubmit}
              >
                {t("global:add")}
              </BMXButton>
            </Col>
          </Row>
        </form>
      )}
    </Form>
  );
};

export default EditServiceValuationPartForm;
